module.exports = __webpack_public_path__ + "img/service_5.ace2927a.png";